/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC File Controls

/**
 * NGC File Module
 */
@NgModule({
    exports: [
    ]
})
export class NgcFileModule {
}